import React, { useState, useEffect, useRef } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import { UncontrolledTooltip, Modal, ModalBody } from 'reactstrap';
import { injectIntl, intlShape } from 'react-intl';
import { number, string } from 'prop-types';
import Icon from '../../../../components/Icon/Icon';
import { FMessage } from '../../../../hoc/IntlComponents';
import PreviewPopover from '../../../../components/Preview/PreviewPopover';
import LandingDownloadChooseFlowBlock from '../../../../components/Offer/LandingDownloadChooseFlowBlock';

const propTypes = {
  id: number.isRequired,
  title: string.isRequired,
  url: string.isRequired,
  name: string.isRequired,
  totalCr: number.isRequired,
  totalEpC: number.isRequired,
  adaptive: number.isRequired,
  intl: intlShape.isRequired,
};

const defaultProps = {
  name: 'landings',
};

const checkMobileString = title => /мобил|mobil/.test(title.toLowerCase());

const getString = (intl, id, defaultMessage) => intl.formatMessage({ id, defaultMessage });

const getResponsiveTooltip = (isAdaptive, title) => {
  if (isAdaptive) {
    return <FMessage id="tooltip.title.responsive" />;
  } else if (checkMobileString(title)) {
    return <FMessage id="tooltip.title.mobile" />;
  }

  return <FMessage id="tooltip.title.non-responsive" />;
};

const OfferLandingsTableItem = ({
  id,
  title,
  totalCr,
  totalEpC,
  adaptive,
  name,
  url,
  offerId,
  isMyOffer,
  offer,
  site_key,
  connectOffer,
  intl,
}) => {
  const {
    modifies: { is_cdn, g },
  } = offer;

  const [previewPopoverIsOpen, togglePreviewPopover] = useState(false);
  const [downloadModalIsOpen, toggleDownloadModal] = useState(false);
  const togglePreview = () => togglePreviewPopover(!previewPopoverIsOpen);
  const toggleDownload = () => toggleDownloadModal(!downloadModalIsOpen);

  const containerRef = useRef(null);

  // useEffect(() => {
  //   document.addEventListener('mousedown', closePopoverOnClickOutside);

  //   return () => {
  //     document.removeEventListener('mousedown', closePopoverOnClickOutside);
  //   };
  // }, []);

  // const closePopoverOnClickOutside = e => {
  //   if (!containerRef.current.contains(e.target)) {
  //     togglePreviewPopover(false);
  //   }
  // };

  const renderDownloadModal = () => (
    <Modal size="md" isOpen={downloadModalIsOpen} toggle={toggleDownload}>
      <ModalBody className="landing-download-modal">
        <LandingDownloadChooseFlowBlock
          offer={offer}
          landingId={id}
          site_key={site_key}
          connectOffer={connectOffer}
          name={name}
        />
      </ModalBody>
    </Modal>
  );
  return (
    <tr>
      <td>
        <a href={url} target="_blank">
          {title}
        </a>
      </td>
      {/* <td className="text-right" ref={containerRef}>
        {isMyOffer && (
          <Icon
            type="eye"
            className="preview-landing-link"
            id={`preview-landing-link-${id}`}
            onClick={togglePreview}
            title={getString(intl, 'offer.landings-table.preview', 'Preview')}
          >
            <PreviewPopover
              target={`preview-landing-link-${id}`}
              id={id}
              offerId={offerId}
              toggle={togglePreview}
              isOpen={previewPopoverIsOpen}
            />
          </Icon>
        )}
      </td> */}
      {!g && <td>{totalCr === 0 ? '—' : totalCr}</td>}
      {/* <td>{totalEpC === 0 ? '—' : totalEpC}</td> */}
      <td className="text-right">
        <span id={`${name}_${id}`}>
          <Icon
            type="monitor"
            className={cn('landing-icon', {
              'is-active': !checkMobileString(title),
            })}
          />
          <Icon
            type="mobile"
            className={cn('landing-icon', {
              'is-active': adaptive > 0 || checkMobileString(title),
            })}
          />
        </span>

        <UncontrolledTooltip
          placement="right"
          target={`${name}_${id}`}
          delay={{ show: 250, hide: 250 }}
        >
          {getResponsiveTooltip(adaptive, title)}
        </UncontrolledTooltip>
      </td>
      {is_cdn ? (
        <td>
          <Icon
            type="download"
            className="download-landing-link"
            id={`download-landing-link-${id}`}
            onClick={toggleDownload}
            title={getString(intl, 'offer.landings-table.download-archive', 'Download archive')}
          />
        </td>
      ) : null}
      {renderDownloadModal()}
    </tr>
  );
};

OfferLandingsTableItem.propTypes = propTypes;
OfferLandingsTableItem.defaultProps = defaultProps;

const mapStateToProps = state => ({
  offerId: state.offers.selected.id,
  isMyOffer: state.offers.selected.modifies.is_my,
});

export default connect(mapStateToProps)(injectIntl(OfferLandingsTableItem));
